import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50e4a496"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "choose-person" }
const _hoisted_2 = { class: "choose-person__list" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "-avatar" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/avatar-bartek.png",
    alt: ""
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "-label" }, "Bartek", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "-desc" }, "senior frontend dev", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "-avatar" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/avatar-aga.png",
    alt: ""
  })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "-label" }, "Aga", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "-desc" }, "junior tester", -1))
const _hoisted_9 = { class: "about-me s-static" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "About us", -1))
const _hoisted_11 = { class: "l-static i-features" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Cats", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Traveling", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Cooking", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/concert.png",
    alt: "Concerts"
  }),
  /*#__PURE__*/_createElementVNode("span", null, "Music concerts")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_component = _resolveComponent("header-component")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_icon_component = _resolveComponent("icon-component")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_header_component, {
      "top-bg": {
      mobile: '/home-bg-mobile.jpg',
      desktop: '/home-bg.jpg',
    },
      heading: "Life is made of challenges, achievements and two cats.",
      "heading-small": "- just us, not Paulo Coelho"
    }, null, 8, ["top-bg"]),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("ul", _hoisted_2, [
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/bartek" }, {
            default: _withCtx(() => [
              _hoisted_3,
              _hoisted_4,
              _hoisted_5
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/aga" }, {
            default: _withCtx(() => [
              _hoisted_6,
              _hoisted_7,
              _hoisted_8
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("ul", _hoisted_11, [
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.CAT,
            size: 60
          }, null, 8, ["icon"]),
          _hoisted_12
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.TRAVEL
          }, null, 8, ["icon"]),
          _hoisted_13
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.COOKING
          }, null, 8, ["icon"]),
          _hoisted_14
        ]),
        _hoisted_15
      ])
    ])
  ], 64))
}